// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import siteMessage from "@insite/client-framework/SiteMessage";
import resetWishLists from "@insite/client-framework/Store/Data/WishLists/Handlers/ResetWishLists";
import { getWishListState } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";
import addWishListTags from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/AddWishListTags";
import removeWishListTags from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/RemoveWishListTags";
import setWishListTags from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/SetWishListTags";
import translate from "@insite/client-framework/Translate";
import { WishListTagModel } from "@insite/client-framework/Types/ApiModels";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import X from "@insite/mobius/Icons/X";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { injectCss, resolveColor } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
// import styled, { css } from "styled-components"; // Starter Custom Code

/* Starter Custom Code - Start */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { FormFieldSizeVariant } from "@insite/mobius/FormField";
import borderByState from "@insite/mobius/FormField/formStyles";
import Tag from "@insite/mobius/Tag";
import FormActions from "@store/Library/Components/Toolkit/FormActions";
import TagWrapper, { TagWrapperProps } from "@store/Library/Components/Toolkit/TagWrapper";
import { formFieldDescriptionWrapperStyles } from "@store/Themes/common/mixins/formField";
import { formSmallGridProps } from "@store/Themes/common/props/form";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import styled, { css, useTheme } from "styled-components";

const tagsFieldSizeVariant: FormFieldSizeVariant = "default";
/* Starter Custom Code - End */

interface OwnProps {
    isOpen: boolean;
    handleClose(): void;
}

type Props = OwnProps;

export interface AddTagsModalStyles {
    modal?: ModalPresentationProps;
    container?: GridContainerProps;
    descriptionGridItem?: GridItemProps;
    descriptionText?: TypographyProps;
    tagsGridItem?: GridItemProps;
    buttonsGridItem?: GridItemProps;
    cancelButton?: ButtonPresentationProps;
    saveButton?: ButtonPresentationProps;
    instructionsStyle?: InjectableCss;
    tagsInstructionGridItem?: GridItemProps;
    tagsInstructionText?: TypographyProps;
    fakeTextFieldStyle?: InjectableCss;
    tagText?: TypographyProps;
    tagCloseText?: TypographyProps;
    tagInputText?: TextFieldPresentationProps;
    // Starter Custom Code
    tagWrapper?: TagWrapperProps;
    tagsDescriptionWrapper?: InjectableCss;
}

export const addTagsModalStyles: AddTagsModalStyles = {
    modal: { sizeVariant: "medium" },
    container: formSmallGridProps.gridContainer,
    descriptionGridItem: { width: 12 },
    tagsGridItem: {
        width: 12,
        css: css`
            display: block;
        `,
    },
    cancelButton: { variant: "secondary" },
    tagsDescriptionWrapper: {
        css: css`
            ${() => formFieldDescriptionWrapperStyles(tagsFieldSizeVariant, true)}
        `,
    },
    tagInputText: {
        cssOverrides: {
            inputSelect: css`
                ${x => x.theme.formField.defaultProps?.cssOverrides?.inputSelect}
                border: none !important;
            `,
        },
    },
    tagWrapper: {
        gap: pxToRem(4),
        extendedStyles: {
            wrapper: {
                css: css`
                    width: 100%;
                    padding: ${pxToRem(4)};
                    box-shadow: ${x => x.theme.shadows.e40};
                `,
            },
        },
    },
};

const FakeTextFieldStyle = styled.div<{ isFocused: boolean } & InjectableCss>`
    /* Starter Custom Code - Start */
    ${({ theme }) =>
        borderByState(
            { border: theme.formField.defaultProps?.border, _sizeVariant: tagsFieldSizeVariant, theme },
            "inactive",
        )}
    /* Starter Custom Code - End */
    width: 100%;
    /* Starter Removed - background */
    /* Starter Removed - padding */
    /* Starter Removed - margin */
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    ${props =>
        props.isFocused
            ? css`
                  border-color: ${props => props.theme.focus.color};
                  border-style: ${props => props.theme.focus.style};
                  border-width: ${props => props.theme.focus.width};
                  /* Starter Removed - padding */
              `
            : ""}
    ${injectCss}
`;

const styles = addTagsModalStyles;

const AddTagsModal = ({ isOpen, handleClose }: Props) => {
    const [tagsControlIsFocused, setTagsControlIsFocused] = useState(false);
    const [tagsValue, setTagsValue] = useState("");
    const wishListId = useAppSelector(state => state.pages.myListDetails.wishListId);
    const wishListDataView = useAppSelector(state => getWishListState(state, state.pages.myListDetails.wishListId));
    const tags = useAppSelector(state => state.pages.myListDetails.wishListTags);
    const addingWishListTags = useAppSelector(state => state.pages.myListDetails.addingWishListTags);
    const removingWishListTags = useAppSelector(state => state.pages.myListDetails.removingWishListTags);
    const theme = useTheme(); // Starter Custom Code

    if (!wishListDataView.value) {
        return null;
    }

    const dispatch = useDispatch();
    const onChange = (event: React.FormEvent<HTMLInputElement>) => {
        setTagsValue(event.currentTarget.value.replace(/[^a-zA-Z0-9\-\_\s]/g, ""));
    };

    const addValue = (value: string) => {
        let currentArray = tags;
        if (!currentArray) {
            currentArray = [];
        }
        const nextValue = value?.trim().toLowerCase();
        if (nextValue && !currentArray.some(o => o.toLowerCase() === nextValue)) {
            currentArray = [...currentArray, nextValue];

            dispatch(setWishListTags({ wishListTags: currentArray }));
        }

        setTagsValue("");
        return currentArray;
    };

    const onKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
            addValue(event.currentTarget.value);
        }
    };

    const removeTag = (tag: string) => {
        const currentArray = [...tags];
        currentArray.splice(currentArray.indexOf(tag), 1);
        dispatch(setWishListTags({ wishListTags: currentArray }));
    };

    const onFocus = () => {
        setTagsControlIsFocused(true);
    };

    const onBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        setTagsControlIsFocused(false);
        const newTags = addValue(tagsValue);
        const id = (event.relatedTarget as any)?.id;
        if (id === "addTagsModal_cancel") {
            handleClose();
        } else if (id === "addTagsModal_save") {
            save(newTags);
        }
    };

    const saveHandler = () => {
        save(tags);
    };

    const save = (newTags: string[]) => {
        const tagsSet = new Set(newTags.map(o => o.toLowerCase()));
        const currentTags = wishListDataView.value.wishListTags || [];
        const tagsToRemove = currentTags.filter(o => !tagsSet.has(o.tag.toLowerCase())).map(o => o.id);
        const currentTagsSet = new Set(currentTags.map(o => o.tag.toLowerCase()));
        const tagsToAdd = newTags
            .filter(o => !currentTagsSet.has(o.toLowerCase()))
            .map(o => {
                return { tag: o } as WishListTagModel;
            });

        if (wishListId && tagsToAdd.length) {
            dispatch(
                addWishListTags({
                    wishListId,
                    tags: tagsToAdd,
                    onComplete: () => {
                        if (!removingWishListTags) {
                            handleClose();
                            dispatch(resetWishLists());
                        }
                    },
                }),
            );
        }
        if (wishListId && tagsToRemove.length) {
            dispatch(
                removeWishListTags({
                    wishListId,
                    wishListTagIds: tagsToRemove,
                    onComplete: () => {
                        if (!addingWishListTags) {
                            handleClose();
                            dispatch(resetWishLists());
                        }
                    },
                }),
            );
        }

        if (!wishListId || (!tagsToAdd.length && !tagsToRemove.length)) {
            handleClose();
        }
    };

    return (
        <Modal
            {...styles.modal}
            handleClose={handleClose}
            headline={translate("Add Tags")}
            isOpen={isOpen}
            // Starter Removed - size
        >
            <GridContainer {...styles.container} data-test-selector="addTagsForm">
                <GridItem {...styles.descriptionGridItem}>
                    <Typography {...styles.descriptionText}>{siteMessage("Lists_Add_Tags_Description")}</Typography>
                </GridItem>
                <GridItem {...styles.tagsGridItem}>
                    <FakeTextFieldStyle isFocused={tagsControlIsFocused} {...styles.fakeTextFieldStyle}>
                        {/* Starter Custom Code - Start */}
                        <TagWrapper {...styles.tagWrapper}>
                            {tags &&
                                tags.map(tag => (
                                    <Tag
                                        key={tag}
                                        data-test-selector={`addTagItem_${tag}`}
                                        onDelete={() => removeTag(tag)}
                                    >
                                        {tag}
                                    </Tag>
                                ))}
                        </TagWrapper>
                        {/* Starter Custom Code - End */}
                        <TextField
                            {...styles.tagInputText}
                            disabled={addingWishListTags || removingWishListTags}
                            type="text"
                            value={tagsValue}
                            onChange={onChange}
                            onKeyPress={onKeyPress}
                            onFocus={onFocus}
                            onBlur={onBlur}
                            pattern="[0-9a-zA-Z_\-\s]"
                            maxLength={50}
                            data-test-selector="myListsAddTagsFormName"
                        />
                    </FakeTextFieldStyle>
                    {/* Starter Custom Code - Start */}
                    <StyledWrapper {...styles.tagsDescriptionWrapper}>
                        <Typography {...theme.formField.defaultProps?.hintProps} {...styles.tagsInstructionText}>
                            {translate('Type and press "Enter" to save')}
                        </Typography>
                    </StyledWrapper>
                    {/* Starter Custom Code - End */}
                </GridItem>
                {/* Starter Removed - buttonsGridItem */}
                {/* Starter Moved - cancelButton & saveButton - down */}
            </GridContainer>
            {/* Starter Custom Code - Start */}
            <FormActions>
                <Button
                    id="addTagsModal_save"
                    {...styles.saveButton}
                    disabled={addingWishListTags || removingWishListTags}
                    onClick={saveHandler}
                    data-test-selector="myListsAddTagsFormSubmit"
                >
                    {translate("Save")}
                </Button>
                <Button
                    id="addTagsModal_cancel"
                    {...styles.cancelButton}
                    onClick={handleClose}
                    data-test-selector="myListsAddTagsFormCancel"
                >
                    {translate("Cancel")}
                </Button>
            </FormActions>
            {/* Starter Custom Code - End */}
        </Modal>
    );
};

export default AddTagsModal;
